var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.667,
    viewBox: "0 0 10 5.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-319.665 -148.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M324.665,154.253a.7.7,0,0,1-.5-.2l-4.3-4.275a.693.693,0,0,1,0-.984.7.7,0,0,1,.99,0l3.8,3.783,3.8-3.782a.7.7,0,0,1,.99,0,.693.693,0,0,1,0,.985l-4.3,4.275A.7.7,0,0,1,324.665,154.253Z",
    fill: "#181818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown2);
export default __webpack_public_path__ + "static/media/arrowdown-2.78fe8517b95191eac9da5df80a55124a.svg";
export { ForwardRef as ReactComponent };